<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Gourmet Detective</h1>
<h2 class="center" id="heading_id_2">A Gourmet Detective Mystery (Book One)</h2>
<h3 class="center sgc-1" id="heading_id_3">Peter King</h3>
<p class="center sgc-2"><span>A MysteriousPress.com</span></p>
<p class="center"><span>Open Road Integrated Media</span></p>
<p class="center"><span>Ebook</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?4fb2762c